import type { RouteObject } from "react-router-dom";

import {
  SocialEvent,
  SocialEventCategory,
  SocialEventCreate,
  SocialEventDetail,
} from "@/features/social-event";

export const SocialEventRoute: RouteObject[] = [
  {
    path: "social-event",
    children: [
      {
        index: true,
        element: <SocialEvent />,
      },
      {
        path: "new",
        element: <SocialEventCreate />,
      },
      {
        path: "category",
        element: <SocialEventCategory />,
      },
      {
        path: ":id",
        element: <SocialEventDetail />,
      },
    ],
  },
];
